import useDebounce from "@/shared/utils/hooks/useDebounce";
import { CFormInput } from "@coreui/react-pro";
import { CFormInputProps } from "@coreui/react-pro/dist/components/form/CFormInput";
import { useEffect, useRef, useState } from "react";

interface ISearchDebounce extends CFormInputProps {
  setSearchKeyword: (keyword: string, name: string) => void;
  delay?: number;
  name: string;
}

const SearchDebounce = (props: ISearchDebounce) => {
  const { value, delay, setSearchKeyword, name, ...inputProps } = props;
  const [debounceSearch, setDebounceSearch] = useState<typeof value>(value);
  const keyword = useDebounce(debounceSearch, delay ?? 1000);
  const inputRef = useRef<HTMLInputElement>(null);

  const handleClear = () => {
    setDebounceSearch("");
    if (inputRef.current) {
      inputRef.current.value = "";
    }
  };

  useEffect(() => {
    setSearchKeyword(keyword, name);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [keyword]);

  useEffect(() => {
    return () => {
      handleClear();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!value && keyword) {
      handleClear();
    }
  }, [value]);

  return (
    <>
      <CFormInput
        onChange={(e) => {
          setDebounceSearch(e.currentTarget.value);
        }}
        ref={inputRef}
        value={debounceSearch}
        {...inputProps}
      />
    </>
  );
};

export default SearchDebounce;
